import { useState } from 'react'
import { apiGet } from 'tennders-stracture/libs/api'
import { CompanyType } from 'tennders-company/common/types/CompanyType'

const useCompanies = () => {
  const [companies, setCompanies] = useState<CompanyType[]>([])
  const [loadingcompanies, setLoadingCompanies] = useState<boolean>(false)

  const fetchCompanies = async () => {
    setLoadingCompanies(true)
    const response = await apiGet('/companies')
    setCompanies(response)
    setLoadingCompanies(false)
  }

  const fetchCompany = async (id) => apiGet(`/companies/${id}`)

  return {
    companies,
    loadingcompanies,
    fetchCompanies,
    fetchCompany
  }
}

export default useCompanies
